import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQ.css';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is ExtraByte?",
      answer: "ExtraByte is an Indian startup offering project-based learning programs designed to provide hands-on experience in various technology domains. We focus on making quality education accessible and affordable for every Indian learner."
    },
    {
      question: "How much do the courses cost?",
      answer: "All our courses are priced at just ₹1500, making quality education accessible to everyone across India, from metro cities to tier-2 and tier-3 towns."
    },
    {
      question: "What kind of certificate will I receive?",
      answer: "Upon successful completion of your course and projects, you will receive a government-recognized certificate that showcases your skills to potential employers in India."
    },
    {
      question: "How long do the courses take?",
      answer: "Each course is designed as an 8-week program. However, you get lifetime access to the course materials, allowing you to learn at your own pace."
    },
    {
      question: "Are the courses suitable for beginners?",
      answer: "Yes! Our courses are designed to cater to learners at different levels. Each course starts with fundamentals and gradually progresses to advanced topics with hands-on projects."
    },
    {
      question: "What is the refund policy?",
      answer: "We offer a refund policy to ensure your satisfaction. Please check our Refund Policy page for detailed information about the terms and conditions."
    },
    {
      question: "Do I need any prior experience?",
      answer: "It depends on the course. Most of our courses start with basics and are suitable for beginners. However, some advanced courses may require foundational knowledge which will be mentioned in the course description."
    },
    {
      question: "Will I get mentor support?",
      answer: "Yes! All our programs include expert guidance and mentorship from experienced professionals who understand the Indian job market and industry requirements."
    },
    {
      question: "Can I access the course materials after completion?",
      answer: "Absolutely! Once you enroll, you get lifetime access to all course materials, allowing you to revisit and refresh your knowledge anytime."
    },
    {
      question: "How do I enroll in a course?",
      answer: "Simply browse our available courses on the home page, click 'Enroll Now' on your preferred course, fill in your details, and complete the payment process. You'll get instant access to the course materials."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <h1>Frequently Asked Questions</h1>
        <p className="faq-intro">
          Find answers to common questions about our courses, certificates, and learning programs.
        </p>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
              <button 
                className="faq-question" 
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <section className="faq-contact">
          <h2>Still have questions?</h2>
          <p>
            If you couldn't find the answer you're looking for, feel free to{' '}
            <Link to="/contact" style={{ color: 'white', textDecoration: 'underline' }}>
              reach out to us
            </Link>
            . We're here to help!
          </p>
        </section>
      </div>
    </div>
  );
}

export default FAQ;
